import React, { Component } from 'react'
import Details from './details'
import { add, min, getItem, toggleNotification } from "./functions";
import Push from 'push.js';
import { connect } from 'react-redux'
import './Item.css'

class Item extends Component {
    state = {
        active: false,
        price: {
            buying: 0,
            selling: 0
        },
        notification:1
    }

    componentDidMount() {
        this.props.tracker && this.setupInitialPrice().then(() =>{
            if (this.props.interval > 0){
                this.notifier = setInterval(this.checkPrice, this.props.interval)
            }
        })
    }

    componentDidUpdate(prevProps,prevState){
        const {interval} = this.props
        if (interval !== prevProps.interval){
            if (interval > 0){
                this.notifier = setInterval(this.checkPrice, interval)
            }else {
                clearInterval(this.notifier)
            }
        }
    }

    toggle = () => this.setState({ active: !this.state.active })

    componentWillUnmount() { clearInterval(this.notifier) }

    setupInitialPrice = () => getItem(this.props.id).then(e => { e && this.updatePrice(e.buying, e.selling) })

    getNotificationMessage = ({ oldBuy, newBuy, oldSell, newSell }) => {
        const buyDiff = this.diff(oldBuy, newBuy);
        const sellDiff = this.diff(oldSell, newSell)
        return `[B](${buyDiff}): ${oldBuy} => ${newBuy}\n[S](${sellDiff}): ${oldSell} => ${newSell}`
    }

    // o = old
    // n = new
    diff = (o, n) => n - o === 0 ? 0 : n - o > 0 ? `+${n - o}` : n - o

    updatePrice = (buying, selling) => this.setState({ price: { buying, selling } })

    checkPrice = () => {
        const {id,name} = this.props
        getItem(id).then(e => {
            const { buying, selling } = this.state.price
            if (e && buying && selling) {
                if (buying !== e.buying || selling !== e.selling) {
                    const pushSettings = {
                        icon: `http://cdn.rsbuddy.com/items/${id}.png`,
                        body: this.getNotificationMessage({
                            oldBuy: buying,
                            newBuy: e.buying,
                            oldSell: selling,
                            newSell: e.selling
                        })
                    }
                    Push.create(name, pushSettings)
                    this.updatePrice(e.buying, e.selling);
                }
            }
        })
    }
    shouldComponentUpdate(prevProps, prevState) {
        return (this.props.type !== prevProps.type || this.state.active !== prevState.active || this.props.interval !== prevProps.interval)
    }
    

    render() {
        const { name, id, type, interval } = this.props
        return (
            <div className="Item">
                <div className="upperline">
                    <img src={`http://cdn.rsbuddy.com/items/${id}.png`}
                        alt={name}
                        onClick={() => window.open(`https://rsbuddy.com/exchange?id=${id}`)} />
                    <div className="name">
                        <div className={`fa fa-info-circle fa-2x ${type}`} onClick={this.toggle} />
                        {this.props.tracker && <div className={`fa fa-bell${interval > 0 ? "-slash" : ""} fa-2x ${type}`} onClick={() => toggleNotification(this.props)} />}
                        {name}
                    </div>
                    <div
                        className={`fa fa-${type === 'add' ? "plus" : "minus"} fa-2x ${type}`}
                        onClick={
                            () =>
                                type === "add"
                                    ? add(this.props)
                                    : min(this.props)
                        } />
                </div>
                {this.state.active && <Details {...this.props} {...this.state} />}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        item: state
    };
}

export default connect(mapStateToProps)(Item)




// WEBPACK FOOTER //
// ./src/ui/item/index.js